export default function boldNumbers (value) {
	value = value
		.split(' ')
		.map(word => (/^\d+$/.test(word)) ? '<strong>' + word + '</strong>' : word)
		.join(' ');
	return value
}